// groupApi.ts
import axios from '../api/axiosSetup3';
import { Group } from '../types/group';

const get = async (): Promise<Group[]> => {
    try {
        const res = await axios.get<any[]>('/lpr_group', {
                params: {
                    select: '*,ext:lpr_subtenant_to_group(subtenant_id)',
                },
            }
        );
        // return res.data;
        return res.data.map(p => ({
            ...p,
            subtenant_id: p.ext?.[0]?.subtenant_id,
        }));
    } catch (error) {
        console.error('Error fetching groups:', error);
        return [];
    }
};

const post = async (data: Group): Promise<Group> => {
    const res = await axios.post<number>('/rpc/sf_group_create', {
        p_name: data.name,
        p_is_white: data.is_white,
    });
    const { group_id, ...data1 } = data;
    return res.status === 200 ? { group_id: res.data, ...data1 } : {} as Group;

    // const maxv = await axios.get<Group[]>(`lpr_group?order=group_id.desc&limit=1`);
    // data.group_id = maxv.data.length == 0 ? 1 : maxv.data[0].group_id + 1;
    // data.group_id = 0; // Убираем group_id из тела запроса, так как он генерируется на сервере
    // const { entity_ids, ...data1 } = data;
    // const res = await axios.post<Group>(
    //     '/lpr_group?select=group_id', 
    //     data1, 
    //     // {
    //     //     headers: {
    //     //         Prefer: 'return=minimal', // <--- PostgREST вернет только статус и заголовки
    //     //         // 'Prefer': 'return=representation' // <--- PostgREST вернет созданную строку
    //     //         // 'Prefer': 'return=headers-only' // <--- для получения только заголовков, в которых будет Location с URL новой записи
    //     //     }
    //     // }    
    // );
    // return res.status === 201 ? { ...res.data, entity_ids } : {} as Group;
}

const put = async (data: Group): Promise<Group> => {
    const { entity_ids, ext, subtenant_id, ...data1 } = data;
    const res = await axios.put<Group>(`/lpr_group?group_id=eq.${data.group_id}&customer_id=eq.${data.customer_id}`, data1);
    return res.status === 204 ? data : {} as Group;
}

const delete_ = async (id: number): Promise<void> => {
    await axios.delete(`/lpr_group?group_id=eq.${id}`);
}

const getGroupToEntity = async (group_id: number): Promise<number[]> => {
    const res = await axios.get('/lpr_group_to_entity?group_id=eq.' + group_id + '&select=entity_id');
    return res.data.map((row: any) => String(row.entity_id));
};

const putGroupToEntity = async (customer_id: number, group_id: number, entity_ids: number[]): Promise<void> => {
    const res = await axios.post('/rpc/sf_group_to_entity_merge', {
        customer_id,
        group_id,
        entity_ids,
    });
};

export const api = {
    get,
    post,
    put,
    delete: delete_,
    getGroupToEntity,
    putGroupToEntity,
};